import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useLocation } from "react-router-dom";

import * as customerActions from "../../actions/customerActions";
import * as projectActions from "../../actions/projectActions";

import ProjectKeywordsList from "./ProjectKeywordsList";
import ProjectKeywordsFilters from "./ProjectKeywordsFilters";

const INITIAL_FILTERS_STATE = {
  customer: [],
  request_nature: [],
  keywords: []
};

const ProjectKeywordsPage = ({ actions, isMobile, loading }) => {
  const [filters, setFilters] = useState(INITIAL_FILTERS_STATE);
  const [currentPage, setCurrentPage] = useState(0);
  const [refetching, setRefetching] = useState(false);

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const customer = searchParams.get("customer");

  useEffect(() => {
    if (customer) {
      actions.loadInProgressCustomerProjects({
        ...INITIAL_FILTERS_STATE,
        customer: [customer]
      });
      setFilters((prev) => ({
        ...prev,
        ...INITIAL_FILTERS_STATE,
        customer: [customer]
      }));
    } else {
      actions.loadInProgressCustomerProjects(INITIAL_FILTERS_STATE);
    }
    return () => actions.clearInProgressCustomerProjects();
  }, [actions, customer]);

  const handleChangeFilters = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const preparePaylod = (page) => ({
    customer: filters.customer.map((c) => c.value || c),
    request_nature: filters.request_nature.map((rn) => rn.value),
    keywords: filters.keywords.map((keyword) => keyword.value),
    page
  });

  const handlePageChange = (page) => {
    setCurrentPage(page);
    actions.loadInProgressCustomerProjects(preparePaylod(page));
  };

  const handleProjectChange = async (projectId, data) => {
    setRefetching(true);
    await actions.updateKeywordsAndRequestNatures(projectId, {
      requestNatures: data.requestNatures || [],
      keywords: data.keywords || []
    });
    await actions.loadInProgressCustomerProjects(preparePaylod(currentPage));
    setRefetching(false);
  };

  const handleResetFilters = () => {
    setFilters(INITIAL_FILTERS_STATE);
    setCurrentPage(0);
    actions.loadInProgressCustomerProjects(INITIAL_FILTERS_STATE);
  };

  const handleFilter = () => {
    setCurrentPage(0);
    actions.loadInProgressCustomerProjects(preparePaylod(0));
  };

  return (
    <React.Fragment>
      <ProjectKeywordsFilters
        isMobile={isMobile}
        filters={filters}
        page={currentPage}
        onChange={handleChangeFilters}
        onReset={handleResetFilters}
        onFilter={handleFilter}
        loading={loading || refetching}
      />
      <ProjectKeywordsList
        page={currentPage}
        refetching={refetching}
        onPageChange={handlePageChange}
        onProjectChange={handleProjectChange}
      />
    </React.Fragment>
  );
};

ProjectKeywordsPage.propTypes = {
  actions: PropTypes.object,
  isMobile: PropTypes.bool,
  loading: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    customers: state.reducers.customers,
    loading: state.reducers.loading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...customerActions,
        ...projectActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(ProjectKeywordsPage);
